import TYPES from '@/modules/shared/types';

// Domain
import {
  RetirementGoalMonthlyPaymentCalculationRepository,
} from '@/modules/flagship/retirement-goal-calculations/domain/repositories/retirement-goal-monthly-payment-calculation-repository';
import {
  RetirementGoalMonthlyPaymentCalculationDto,
} from '@/modules/flagship/retirement-goal-calculations/domain/dtos/retirement-goal-monthly-payment-calculation-dto';
import {
  RetirementGoalMonthlyPaymentCalculationEntity,
} from '@/modules/flagship/retirement-goal-calculations/domain/entities/retirement-goal-monthly-payment-calculation-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
class RetirementGoalMonthlyPaymentCalculationHttpRepository
implements RetirementGoalMonthlyPaymentCalculationRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/flagship/retirement-investor-goal-monthly-required-amount-forecast-calculation/`;

  calculate(
    payload: RetirementGoalMonthlyPaymentCalculationDto,
  ): Promise<RetirementGoalMonthlyPaymentCalculationEntity> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint, 'POST', payload)
        .then((response) => {
          response.json()
            .then(({ success, data, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}

export default RetirementGoalMonthlyPaymentCalculationHttpRepository;
